import React from 'react'

export function Container({children}) {
  return <div className="container">{children}</div>
}
